export default __webpack_public_path__ + "static/media/01.e1b7507d.png";